module.exports = __webpack_public_path__ + "img/canva.7b56ba04.jpg";